<template>
    <div>
        <basis-theory-form
            v-if="activeTokenizerIsBasisTheory"
            ref="basisTheoryForm"
            @set-loading="(onOrOff) => $emit('set-loading', onOrOff)"
            @token-created="(data) => $emit('token-created', data)"
            @token-error="(err) => $emit('token-error', err)"
        />
        <fluid-pay-form
            v-else-if="activeTokenizerIsFluidpay"
            ref="fluidPayForm"
            :api-key="fluidpayApiKey"
            :api-url="fluidpayApiUrl"
            :first-name="firstName"
            :last-name="lastName"
            @set-loading="(onOrOff) => $emit('set-loading', onOrOff)"
            @verified="(data) => $emit('verified', data)"
            @token-error="(err) => $emit('token-error', err)"
        />
        <payliance-form
            v-else-if="activeTokenizerIsPayliance"
            ref="paylianceForm"
            :configuration="paylianceConfiguration"
            @set-loading="(onOrOff) => $emit('set-loading', onOrOff)"
            @verified="(data) => $emit('verified', data)"
            @token-error="(err) => $emit('token-error', err)"
        />
    </div>
</template>

<script>
import BasisTheoryForm from './BasisTheoryForm.vue';
import FluidPayForm from './FluidPayForm.vue';
import PaylianceForm from './PaylianceForm.vue';

export default {
    name: 'TokenizerForm',

    components: {
        BasisTheoryForm,
        FluidPayForm,
        PaylianceForm,
    },

    props: {
        tokenizer: {
            type: String,
            default: 'basis-theory',
        },
        fluidpayApiKey: {
            type: String,
            default: '',
        },
        fluidpayApiUrl: {
            type: String,
            default: '',
        },
        paylianceConfiguration: {
            type: Object,
            default: null,
        },
        firstName: {
            type: String,
            default: '',
        },
        lastName: {
            type: String,
            default: '',
        },
    },

    computed: {
        activeTokenizer() {
            console.log(`Active tokenizer: ${this.tokenizer}`);
            return this.tokenizer || 'basis-theory';
        },
        activeTokenizerIsBasisTheory() {
            return this.activeTokenizer === 'basis-theory';
        },
        activeTokenizerIsFluidpay() {
            return this.activeTokenizer === 'fluidpay';
        },
        activeTokenizerIsPayliance() {
            return this.activeTokenizer === 'payliance';
        },

        // Proxied accessors so the parent mixin can use this.$refs.tokenizerForm.firstName etc.
        innerFirstName() {
            if (this.activeTokenizerIsBasisTheory && this.$refs.basisTheoryForm) {
                return this.$refs.basisTheoryForm.firstName;
            }
            if (this.activeTokenizerIsFluidpay && this.$refs.fluidPayForm) {
                return this.$refs.fluidPayForm.localFirstName;
            }
            return this.firstName;
        },
        innerLastName() {
            if (this.activeTokenizerIsBasisTheory && this.$refs.basisTheoryForm) {
                return this.$refs.basisTheoryForm.lastName;
            }
            if (this.activeTokenizerIsFluidpay && this.$refs.fluidPayForm) {
                return this.$refs.fluidPayForm.localLastName;
            }
            return this.lastName;
        },
        innerZipCode() {
            if (this.activeTokenizerIsBasisTheory && this.$refs.basisTheoryForm) {
                return this.$refs.basisTheoryForm.zipCode;
            }
            return '';
        },
    },

    methods: {
        /**
         * Trigger card submission on the active tokenizer form.
         * Called by the parent screen or mixin (e.g. this.$refs.tokenizerForm.submitCard()).
         */
        submitCard() {
            if (this.activeTokenizerIsBasisTheory && this.$refs.basisTheoryForm) {
                this.$refs.basisTheoryForm.submitCard();
            } else if (this.activeTokenizerIsFluidpay && this.$refs.fluidPayForm) {
                this.$refs.fluidPayForm.submitCard();
            } else if (this.activeTokenizerIsPayliance && this.$refs.paylianceForm) {
                this.$refs.paylianceForm.submitCard();
            }
        },
    },
};
</script>
